module.exports = __webpack_public_path__ + "static/media/castle.dc860724.png";